import React from 'react';
import { DropletIcon, TrashIcon } from 'lucide-react';
interface BottleProps {
  label: string;
  color: string;
  level: number;
  filling: boolean;
  icon: 'drop' | 'virus' | 'trash';
}
export const Bottle: React.FC<BottleProps> = ({
  label,
  color,
  level,
  filling,
  icon
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'drop':
        return <DropletIcon size={18} className="text-blue-500" data-id="element-15" />;
      case 'virus':
        return <div size={18} className="text-orange-500" data-id="element-16" />;
      case 'trash':
        return <TrashIcon size={18} className="text-gray-500" data-id="element-17" />;
      default:
        return null;
    }
  };
  return <div className="flex flex-col items-center" data-id="element-18">
      <div className="mb-1" data-id="element-19">{getIcon()}</div>
      <div className="text-xs font-medium mb-1" data-id="element-20">{label}</div>
      <div className="w-16 h-32 border-2 border-gray-300 dark:border-gray-600 rounded-lg relative overflow-hidden" data-id="element-21">
        <div className={`absolute bottom-0 left-0 right-0 transition-all duration-1000 ${filling ? 'animate-pulse' : ''}`} style={{
        height: `${level}%`,
        backgroundColor: color,
        opacity: 0.7
      }} data-id="element-22"></div>
        {/* Level markers */}
        <div className="absolute inset-0 flex flex-col justify-between py-1.5 pointer-events-none" data-id="element-23">
          <div className="w-full border-t border-gray-400 dark:border-gray-500 opacity-50" data-id="element-24"></div>
          <div className="w-full border-t border-gray-400 dark:border-gray-500 opacity-50" data-id="element-25"></div>
          <div className="w-full border-t border-gray-400 dark:border-gray-500 opacity-50" data-id="element-26"></div>
          <div className="w-full border-t border-gray-400 dark:border-gray-500 opacity-50" data-id="element-27"></div>
        </div>
        {/* Level percentage */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-28">
          <span className="text-[10px] font-bold text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 bg-opacity-70 dark:bg-opacity-70 px-1 rounded" data-id="element-29">
            {level}%
          </span>
        </div>
      </div>
    </div>;
};